import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequest } from 'utils/http'

export const getBusySeats = async ({ eventId }: { eventId: string | number }): Promise<Array<string>> => {
  const { data } = await HttpRequest.get<{ seats: Array<string> }>(ApiEndpoint.event.mapSeatsBusy(eventId))
  return data.seats
}
